// src/contexts/NavigationContext.js
import React, { createContext, useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const NavigationContext = createContext();

export const NavigationContextProvider = ({ children }) => {
  const location = useLocation();
  const previousLocation = useRef(null);

  useEffect(() => {
    previousLocation.current = location;

  }, [location]);

  return (
    <NavigationContext.Provider value={previousLocation.current}>
      {children}
    </NavigationContext.Provider>
  );
};

export const usePreviousLocation = () => {
  return useContext(NavigationContext);
};
